export default "__VITE_ASSET__C8SoF0ck__"